import { uid } from './utils';

/** Choix « créer ce client » dans l'écran de vérification. */
export const NOUVEAU_CLIENT = 'nouveau';

/** Unités rendues par le serveur, écrites comme dans les devis. */
const UNITES = { m2: 'm²', m3: 'm³', fft: 'forfait' };

/** L'unité telle que l'écran des devis l'écrit. */
export const uniteDevis = (u) => UNITES[(u || '').toLowerCase()] || u || '';

/**
 * Le brouillon d'offre tiré d'une feuille de notes lue par le Pack IA.
 *
 * Le client reconnu est présélectionné ; à défaut, la fiche lue est proposée à
 * la création. Les lignes gardent leur prix du catalogue, ou un prix vide —
 * non zéro : un prix à saisir ne doit pas se lire « 0.00 ».
 *
 * @param {object} lu réponse du serveur
 * @returns {object} le brouillon à vérifier
 */
export function brouillonDepuisNotes(lu) {
  const client = lu?.client || null;
  const existant = client?.existant || null;
  const candidats = [existant, ...(client?.candidats || [])].filter(Boolean);
  return {
    titre: lu?.titre || '',
    corrections: lu?.corrections || [],
    candidats,
    choixClient: existant ? String(existant.id) : client?.nom ? NOUVEAU_CLIENT : '',
    nouveauClient: {
      nom: client?.nom || '',
      adr: client?.adresse || '',
      npa: client?.npa || '',
      tel: client?.telephone || '',
      email: client?.email || '',
    },
    lignes: (lu?.lignes || []).map((l) => ({
      id: uid(),
      d: l.designation || '',
      q: l.quantite ?? '',
      u: uniteDevis(l.unite),
      p: l.prixUnitaire ?? '',
      tva: l.tauxTva ?? null,
      nouveau: l.nouveau === true,
      alertes: l.alertes || [],
      catalogue: l.rapprochement?.nom || '',
      ref: l.rapprochement?.reference || undefined,
    })),
  };
}

/** Vrai si la ligne attend encore son prix. */
export const sansPrix = (l) => l.p === '' || l.p == null;

/**
 * Ce que l'écran des devis reçoit, une fois le brouillon vérifié.
 *
 * @param {object} brouillon brouillon vérifié
 * @returns {{client: ({id: *}|{fiche: object}|null), titre: string, lignes: object[]}}
 *   le client choisi (existant ou à créer), l'objet et les lignes au format des devis
 */
export function offreDepuisNotes(brouillon) {
  const choix = brouillon?.choixClient || '';
  let client = null;
  if (choix === NOUVEAU_CLIENT) {
    const f = brouillon.nouveauClient || {};
    if ((f.nom || '').trim()) {
      client = {
        fiche: {
          nom: f.nom.trim(),
          adr: (f.adr || '').trim(),
          npa: (f.npa || '').trim(),
          tel: (f.tel || '').trim(),
          email: (f.email || '').trim(),
        },
      };
    }
  } else if (choix) {
    const trouve = (brouillon.candidats || []).find((c) => String(c.id) === choix);
    if (trouve) client = { id: trouve.id };
  }
  const lignes = (brouillon?.lignes || [])
    .filter((l) => (l.d || '').trim())
    .map((l) => ({
      id: uid(),
      d: l.d.trim(),
      sd: '',
      u: l.u || 'pce',
      q: +l.q || 0,
      p: +l.p || 0,
      rem: 0,
      tva: l.tva ?? null,
      ref: l.ref,
    }));
  return { client, titre: (brouillon?.titre || '').trim(), lignes };
}
